import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/media/svg/misc/eolic-energy.svg'
import _imports_1 from '@/assets/media/svg/misc/hot-air-balloon.svg'
import _imports_2 from '@/assets/media/svg/misc/puzzle.svg'
import _imports_3 from '@/assets/media/svg/misc/infography.svg'
import _imports_4 from '@/assets/media/icons/duotone/General/User.svg'
import _imports_5 from '@/assets/media/icons/duotone/Communication/Mail-at.svg'
import _imports_6 from '@/assets/media/icons/duotone/Communication/Call.svg'
import _imports_7 from '@/assets/media/icons/duotone/Home/Home2.svg'
import _imports_8 from '@/assets/media/icons/duotone/Communication/Shield-user.svg'
import _imports_9 from '@/assets/media/icons/duotone/Interface/File-Plus.svg'
import _imports_10 from '@/assets/media/icons/duotone/Home/Clock.svg'
import _imports_11 from '@/assets/media/icons/duotone/Interface/Calendar.svg'


const _hoisted_1 = { class: "row g-5 g-xl-8" }
const _hoisted_2 = { class: "col-xl-3" }
const _hoisted_3 = { class: "card card-xl-stretch mb-xl-8" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createVNode("span", { class: "card-label fw-bolder text-dark" }, "Info")
  ])
], -1)
const _hoisted_5 = { class: "card-body pt-5" }
const _hoisted_6 = { class: "d-flex align-items-center mb-7" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "symbol symbol-50px me-5" }, [
  /*#__PURE__*/_createVNode("span", { class: "symbol-label" }, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_0,
      class: "h-50 align-self-center",
      alt: ""
    })
  ])
], -1)
const _hoisted_8 = { class: "d-flex flex-column" }
const _hoisted_9 = { class: "text-dark fs-6 fw-bolder" }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "text-muted fw-bold" }, "Invoice Number", -1)
const _hoisted_11 = { class: "d-flex align-items-center mb-7" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "symbol symbol-50px me-5" }, [
  /*#__PURE__*/_createVNode("span", { class: "symbol-label" }, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_1,
      class: "h-50 align-self-center",
      alt: ""
    })
  ])
], -1)
const _hoisted_13 = { class: "d-flex flex-column" }
const _hoisted_14 = { class: "text-dark fs-6 fw-bolder" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "text-muted fw-bold" }, "Type", -1)
const _hoisted_16 = { class: "d-flex align-items-center mb-7" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "symbol symbol-50px me-5" }, [
  /*#__PURE__*/_createVNode("span", { class: "symbol-label" }, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_2,
      class: "h-50 align-self-center",
      alt: ""
    })
  ])
], -1)
const _hoisted_18 = { class: "d-flex flex-column" }
const _hoisted_19 = { class: "text-dark fs-6 fw-bolder" }
const _hoisted_20 = /*#__PURE__*/_createVNode("span", { class: "text-muted fw-bold" }, "VA Number", -1)
const _hoisted_21 = { class: "d-flex align-items-center mb-7" }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "symbol symbol-50px me-5" }, [
  /*#__PURE__*/_createVNode("span", { class: "symbol-label" }, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_3,
      class: "h-50 align-self-center",
      alt: ""
    })
  ])
], -1)
const _hoisted_23 = { class: "d-flex flex-column" }
const _hoisted_24 = { class: "text-dark fs-6 fw-bolder" }
const _hoisted_25 = /*#__PURE__*/_createVNode("span", { class: "text-muted fw-bold" }, "Status", -1)
const _hoisted_26 = { class: "col-xl-3" }
const _hoisted_27 = { class: "card card-xl-stretch mb-xl-8" }
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createVNode("span", { class: "card-label fw-bolder text-dark" }, "Customer")
  ])
], -1)
const _hoisted_29 = { class: "card-body pt-5" }
const _hoisted_30 = { class: "d-flex align-items-center mb-7" }
const _hoisted_31 = { class: "symbol symbol-50px me-5" }
const _hoisted_32 = { class: "bg-light-primary symbol-label" }
const _hoisted_33 = { class: "svg-icon-primary svg-icon svg-icon-2x" }
const _hoisted_34 = { class: "d-flex flex-column" }
const _hoisted_35 = { class: "text-dark fs-6 fw-bolder" }
const _hoisted_36 = /*#__PURE__*/_createVNode("span", { class: "text-muted fw-bold" }, "Name", -1)
const _hoisted_37 = { class: "d-flex align-items-center mb-7" }
const _hoisted_38 = { class: "symbol symbol-50px me-5" }
const _hoisted_39 = { class: "bg-light-warning symbol-label" }
const _hoisted_40 = { class: "svg-icon-warning svg-icon svg-icon-2x" }
const _hoisted_41 = { class: "d-flex flex-column" }
const _hoisted_42 = { class: "text-dark fs-6 fw-bolder" }
const _hoisted_43 = /*#__PURE__*/_createVNode("span", { class: "text-muted fw-bold" }, "Email", -1)
const _hoisted_44 = { class: "d-flex align-items-center mb-7" }
const _hoisted_45 = { class: "symbol symbol-50px me-5" }
const _hoisted_46 = { class: "bg-light-danger symbol-label" }
const _hoisted_47 = { class: "svg-icon-danger svg-icon svg-icon-2x" }
const _hoisted_48 = { class: "d-flex flex-column" }
const _hoisted_49 = { class: "text-dark fs-6 fw-bolder" }
const _hoisted_50 = /*#__PURE__*/_createVNode("span", { class: "text-muted fw-bold" }, "Phone", -1)
const _hoisted_51 = { class: "d-flex align-items-center mb-7" }
const _hoisted_52 = { class: "symbol symbol-50px me-5" }
const _hoisted_53 = { class: "bg-light-dark symbol-label" }
const _hoisted_54 = { class: "svg-icon-dark svg-icon svg-icon-2x" }
const _hoisted_55 = { class: "d-flex flex-column" }
const _hoisted_56 = { class: "text-dark fs-6 fw-bolder" }
const _hoisted_57 = /*#__PURE__*/_createVNode("span", { class: "text-muted fw-bold" }, "Address", -1)
const _hoisted_58 = { class: "col-xl-3" }
const _hoisted_59 = { class: "card card-xl-stretch mb-xl-8" }
const _hoisted_60 = /*#__PURE__*/_createVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createVNode("span", { class: "card-label fw-bolder text-dark" }, "Amount")
  ])
], -1)
const _hoisted_61 = { class: "card-body pt-5" }
const _hoisted_62 = { class: "d-flex align-items-center mb-7" }
const _hoisted_63 = /*#__PURE__*/_createVNode("span", { class: "bullet bullet-vertical h-40px bg-success me-5" }, null, -1)
const _hoisted_64 = { class: "d-flex flex-column" }
const _hoisted_65 = { class: "text-dark fs-6 fw-bolder" }
const _hoisted_66 = /*#__PURE__*/_createVNode("span", { class: "text-muted fw-bold" }, "Total Amount", -1)
const _hoisted_67 = { class: "d-flex align-items-center mb-7" }
const _hoisted_68 = /*#__PURE__*/_createVNode("span", { class: "bullet bullet-vertical h-40px bg-dark me-5" }, null, -1)
const _hoisted_69 = { class: "d-flex flex-column" }
const _hoisted_70 = { class: "text-dark fs-6 fw-bolder" }
const _hoisted_71 = /*#__PURE__*/_createVNode("span", { class: "text-muted fw-bold" }, "Billed Amount", -1)
const _hoisted_72 = { class: "d-flex align-items-center mb-7" }
const _hoisted_73 = /*#__PURE__*/_createVNode("span", { class: "bullet bullet-vertical h-40px bg-info me-5" }, null, -1)
const _hoisted_74 = { class: "d-flex flex-column" }
const _hoisted_75 = { class: "text-dark fs-6 fw-bolder" }
const _hoisted_76 = /*#__PURE__*/_createVNode("span", { class: "text-muted fw-bold" }, "Paid Amount", -1)
const _hoisted_77 = { class: "d-flex align-items-center mb-7" }
const _hoisted_78 = /*#__PURE__*/_createVNode("span", { class: "bullet bullet-vertical h-40px bg-secondary me-5" }, null, -1)
const _hoisted_79 = { class: "d-flex flex-column" }
const _hoisted_80 = { class: "text-dark fs-6 fw-bolder" }
const _hoisted_81 = /*#__PURE__*/_createVNode("span", { class: "text-muted fw-bold" }, "Admin Fee", -1)
const _hoisted_82 = { class: "col-xl-3" }
const _hoisted_83 = { class: "card card-xl-stretch mb-xl-8" }
const _hoisted_84 = /*#__PURE__*/_createVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createVNode("span", { class: "card-label fw-bolder text-dark" }, "Other")
  ])
], -1)
const _hoisted_85 = { class: "card-body pt-5" }
const _hoisted_86 = { class: "d-flex align-items-center mb-7" }
const _hoisted_87 = { class: "symbol symbol-45px w-40px me-5" }
const _hoisted_88 = { class: "symbol-label bg-lighten" }
const _hoisted_89 = { class: "svg-icon svg-icon-1" }
const _hoisted_90 = { class: "d-flex flex-column" }
const _hoisted_91 = { class: "text-dark fs-6 fw-bolder" }
const _hoisted_92 = /*#__PURE__*/_createVNode("span", { class: "text-muted fw-bold" }, "Name", -1)
const _hoisted_93 = { class: "d-flex align-items-center mb-7" }
const _hoisted_94 = { class: "symbol symbol-45px w-40px me-5" }
const _hoisted_95 = { class: "symbol-label bg-lighten" }
const _hoisted_96 = { class: "svg-icon svg-icon-1" }
const _hoisted_97 = { class: "d-flex flex-column" }
const _hoisted_98 = { class: "text-dark fs-7 fw-bolder" }
const _hoisted_99 = /*#__PURE__*/_createVNode("span", { class: "text-muted fw-bold" }, "Description", -1)
const _hoisted_100 = { class: "d-flex align-items-center mb-7" }
const _hoisted_101 = { class: "symbol symbol-45px w-40px me-5" }
const _hoisted_102 = { class: "symbol-label bg-lighten" }
const _hoisted_103 = { class: "svg-icon svg-icon-1" }
const _hoisted_104 = { class: "d-flex flex-column" }
const _hoisted_105 = { class: "text-dark fs-6 fw-bolder" }
const _hoisted_106 = /*#__PURE__*/_createVNode("span", { class: "text-muted fw-bold" }, "Due Date", -1)
const _hoisted_107 = { class: "d-flex align-items-center mb-7" }
const _hoisted_108 = { class: "symbol symbol-45px w-40px me-5" }
const _hoisted_109 = { class: "symbol-label bg-lighten" }
const _hoisted_110 = { class: "svg-icon svg-icon-1" }
const _hoisted_111 = { class: "d-flex flex-column" }
const _hoisted_112 = { class: "text-dark fs-6 fw-bolder" }
const _hoisted_113 = /*#__PURE__*/_createVNode("span", { class: "text-muted fw-bold" }, "Valid Until", -1)
const _hoisted_114 = {
  key: 0,
  class: "col-xl-12"
}
const _hoisted_115 = { class: "card card-xl-stretch mb-xl-8 px-10 pb-10" }
const _hoisted_116 = /*#__PURE__*/_createVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createVNode("span", { class: "card-label fw-bolder text-dark" }, "Components")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("section", null, [
    _withDirectives(_createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode("div", _hoisted_8, [
                _createVNode("span", _hoisted_9, _toDisplayString(_ctx.data?.data.invocation_bill &&
                    _ctx.data?.data.invocation_bill.invoice_number ? _ctx.data?.data.invocation_bill.invoice_number : '-'), 1),
                _hoisted_10
              ])
            ]),
            _createVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode("div", _hoisted_13, [
                _createVNode("span", _hoisted_14, _toDisplayString(_ctx.data?.data.invocation_bill && _ctx.data?.data.invocation_bill.type
                    ? _ctx.data?.data.invocation_bill.type.toUpperCase() : '-'), 1),
                _hoisted_15
              ])
            ]),
            _createVNode("div", _hoisted_16, [
              _hoisted_17,
              _createVNode("div", _hoisted_18, [
                _createVNode("span", _hoisted_19, _toDisplayString(_ctx.data?.data.invocation_bill &&
                    _ctx.data?.data.invocation_bill.va_number ? _ctx.data?.data.invocation_bill.va_number : '-'), 1),
                _hoisted_20
              ])
            ]),
            _createVNode("div", _hoisted_21, [
              _hoisted_22,
              _createVNode("div", _hoisted_23, [
                _createVNode("span", _hoisted_24, _toDisplayString(_ctx.data?.data.invocation_bill &&
                    _ctx.data?.data.invocation_bill.status ? _ctx.data?.data.invocation_bill.status.toUpperCase() : '-'), 1),
                _hoisted_25
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_26, [
        _createVNode("div", _hoisted_27, [
          _hoisted_28,
          _createVNode("div", _hoisted_29, [
            _createVNode("div", _hoisted_30, [
              _createVNode("div", _hoisted_31, [
                _createVNode("span", _hoisted_32, [
                  _createVNode("span", _hoisted_33, [
                    _createVNode(_component_inline_svg, { src: _imports_4 })
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_34, [
                _createVNode("span", _hoisted_35, _toDisplayString(_ctx.data?.data.invocation_bill &&
                    _ctx.data?.data.invocation_bill.customer_name ? _ctx.data?.data.invocation_bill.customer_name : '-'), 1),
                _hoisted_36
              ])
            ]),
            _createVNode("div", _hoisted_37, [
              _createVNode("div", _hoisted_38, [
                _createVNode("span", _hoisted_39, [
                  _createVNode("span", _hoisted_40, [
                    _createVNode(_component_inline_svg, { src: _imports_5 })
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_41, [
                _createVNode("span", _hoisted_42, _toDisplayString(_ctx.data?.data.invocation_bill &&
                    _ctx.data?.data.invocation_bill.customer_email ? _ctx.data?.data.invocation_bill.customer_email : '-'), 1),
                _hoisted_43
              ])
            ]),
            _createVNode("div", _hoisted_44, [
              _createVNode("div", _hoisted_45, [
                _createVNode("span", _hoisted_46, [
                  _createVNode("span", _hoisted_47, [
                    _createVNode(_component_inline_svg, { src: _imports_6 })
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_48, [
                _createVNode("span", _hoisted_49, _toDisplayString(_ctx.data?.data.invocation_bill &&
                    _ctx.data?.data.invocation_bill.customer_phone ? _ctx.data?.data.invocation_bill.customer_phone : '-'), 1),
                _hoisted_50
              ])
            ]),
            _createVNode("div", _hoisted_51, [
              _createVNode("div", _hoisted_52, [
                _createVNode("span", _hoisted_53, [
                  _createVNode("span", _hoisted_54, [
                    _createVNode(_component_inline_svg, { src: _imports_7 })
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_55, [
                _createVNode("span", _hoisted_56, _toDisplayString(_ctx.data?.data.invocation_bill &&
                    _ctx.data?.data.invocation_bill.customer_address ? _ctx.data?.data.invocation_bill.customer_address : '-'), 1),
                _hoisted_57
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_58, [
        _createVNode("div", _hoisted_59, [
          _hoisted_60,
          _createVNode("div", _hoisted_61, [
            _createVNode("div", _hoisted_62, [
              _hoisted_63,
              _createVNode("div", _hoisted_64, [
                _createVNode("span", _hoisted_65, _toDisplayString(_ctx.data?.data.invocation_bill &&
                    _ctx.data?.data.invocation_bill.total_amount ?
                    _ctx.numberFormat(_ctx.data?.data.invocation_bill.total_amount.toString()) : '-'), 1),
                _hoisted_66
              ])
            ]),
            _createVNode("div", _hoisted_67, [
              _hoisted_68,
              _createVNode("div", _hoisted_69, [
                _createVNode("span", _hoisted_70, _toDisplayString(_ctx.data?.data.invocation_bill &&
                    _ctx.data?.data.invocation_bill.billed_amount ?
                    _ctx.numberFormat(_ctx.data?.data.invocation_bill.billed_amount.toString()) : '-'), 1),
                _hoisted_71
              ])
            ]),
            _createVNode("div", _hoisted_72, [
              _hoisted_73,
              _createVNode("div", _hoisted_74, [
                _createVNode("span", _hoisted_75, _toDisplayString(_ctx.data?.data.invocation_bill &&
                    _ctx.data?.data.invocation_bill.paid_amount ?
                    _ctx.numberFormat(_ctx.data?.data.invocation_bill.paid_amount.toString()) : '-'), 1),
                _hoisted_76
              ])
            ]),
            _createVNode("div", _hoisted_77, [
              _hoisted_78,
              _createVNode("div", _hoisted_79, [
                _createVNode("span", _hoisted_80, _toDisplayString(_ctx.data?.data.invocation_bill &&
                    _ctx.data?.data.invocation_bill.admin_fee ? _ctx.numberFormat(_ctx.data?.data.invocation_bill.admin_fee.toString()) :
                    '-'), 1),
                _hoisted_81
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_82, [
        _createVNode("div", _hoisted_83, [
          _hoisted_84,
          _createVNode("div", _hoisted_85, [
            _createVNode("div", _hoisted_86, [
              _createVNode("div", _hoisted_87, [
                _createVNode("span", _hoisted_88, [
                  _createVNode("span", _hoisted_89, [
                    _createVNode(_component_inline_svg, { src: _imports_8 })
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_90, [
                _createVNode("span", _hoisted_91, _toDisplayString(_ctx.data?.data.invocation_bill && _ctx.data?.data.invocation_bill.name
                    ? _ctx.data?.data.invocation_bill.name : '-'), 1),
                _hoisted_92
              ])
            ]),
            _createVNode("div", _hoisted_93, [
              _createVNode("div", _hoisted_94, [
                _createVNode("span", _hoisted_95, [
                  _createVNode("span", _hoisted_96, [
                    _createVNode(_component_inline_svg, { src: _imports_9 })
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_97, [
                _createVNode("span", _hoisted_98, _toDisplayString(_ctx.data?.data.invocation_bill &&
                    _ctx.data?.data.invocation_bill.description ? _ctx.data?.data.invocation_bill.description : '-'), 1),
                _hoisted_99
              ])
            ]),
            _createVNode("div", _hoisted_100, [
              _createVNode("div", _hoisted_101, [
                _createVNode("span", _hoisted_102, [
                  _createVNode("span", _hoisted_103, [
                    _createVNode(_component_inline_svg, { src: _imports_10 })
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_104, [
                _createVNode("span", _hoisted_105, _toDisplayString(_ctx.data?.data.invocation_bill &&
                    _ctx.data?.data.invocation_bill.due_date ? _ctx.data?.data.invocation_bill.due_date : '-'), 1),
                _hoisted_106
              ])
            ]),
            _createVNode("div", _hoisted_107, [
              _createVNode("div", _hoisted_108, [
                _createVNode("span", _hoisted_109, [
                  _createVNode("span", _hoisted_110, [
                    _createVNode(_component_inline_svg, { src: _imports_11 })
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_111, [
                _createVNode("span", _hoisted_112, _toDisplayString(_ctx.data?.data.invocation_bill &&
                    _ctx.data?.data.invocation_bill.valid_until ? _ctx.data?.data.invocation_bill.valid_until :
                    '-'), 1),
                _hoisted_113
              ])
            ])
          ])
        ])
      ]),
      (_ctx.data?.data.invocation_bill && _ctx.data?.data.invocation_bill.components)
        ? (_openBlock(), _createBlock("div", _hoisted_114, [
            _createVNode("div", _hoisted_115, [
              _hoisted_116,
              _createVNode(_component_el_table, {
                class: "Bill-table fs-7",
                data: _ctx.data?.data.invocation_bill.components,
                border: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "id",
                    label: _ctx.$t('bill.component.id')
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    prop: "name",
                    label: _ctx.$t('bill.component.name')
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    align: "right",
                    prop: "price",
                    label: _ctx.$t('bill.component.price')
                  }, {
                    default: _withCtx((prop) => [
                      _createTextVNode(_toDisplayString(_ctx.numberFormat(prop.row.price.toString())), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    align: "right",
                    prop: "qty",
                    label: _ctx.$t('bill.component.qty')
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    align: "right",
                    prop: "total",
                    label: _ctx.$t('bill.component.total')
                  }, {
                    default: _withCtx((prop) => [
                      _createTextVNode(_toDisplayString(_ctx.numberFormat(prop.row.total.toString())), 1)
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }, 8, ["data"])
            ])
          ]))
        : _createCommentVNode("", true)
    ], 512), [
      [_directive_loading, !_ctx.data]
    ])
  ]))
}